/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithSignupMax
 */
export interface WithSignupMaxOptional {
  /**
   *
   * @type {number}
   * @memberof WithSignupMax
   */
  signupMax?: number;
}

export interface WithSignupMax extends WithSignupMaxOptional {
  /**
   *
   * @type {number}
   * @memberof WithSignupMax
   */
  signupMax?: number;
}

export interface WithSignupMaxTrackedI {
  /**
   *
   * @type {number}
   * @memberof WithSignupMax
   */
  signupMax?: number;
  signupMaxIsSet: boolean;
}

transformDatesMap.set("WithSignupMax", function (model: WithSignupMax) {});

export type WithSignupMaxMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  signupMax: PropertyMeta<MetaTypeBase<number>>;
}>;

export var WithSignupMaxMeta: WithSignupMaxMetaI = {} as WithSignupMaxMetaI;
WithSignupMaxMeta = typeMeta("WithSignupMax", {
  signupMax: propertyMeta(
    "signupMax",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = WithSignupMaxMeta;

registerMeta(() => {});

export class WithSignupMaxTracked implements WithSignupMaxTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  signupMax__I?: number = undefined;
  signupMaxIsSet: boolean = false;
  set signupMax(v: undefined | number) {
    if (v !== undefined) {
      this.signupMax__I = v;
      this.signupMaxIsSet = true;
    } else {
      this.signupMax__I = v || undefined;
      this.signupMaxIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMax() {
    return this.signupMax__I;
  }
  constructor(config?: WithSignupMaxOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithSignupMaxOptional,
    options?: AssignOptions,
  ): WithSignupMaxTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.signupMax && this.signupMaxApplyFilter(optionsRequired.filter)) {
      this.signupMax = config.signupMax;
      if (optionsRequired.unassign) this.signupMaxIsSet = false;
      else this.signupMaxIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithSignupMaxTrackedI {
    const cloned = {} as WithSignupMaxTrackedI;
    if (
      this.signupMaxIsSetDeep() &&
      this.signupMaxApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMaxIsSet = true;
      cloned.signupMax = this.signupMax;
    } else {
      //cloned.signupMaxIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithSignupMaxTrackedI {
    if (!this.signupMaxApplyFilter(filter)) this.signupMaxIsSet = false;

    return this;
  }
  signupMaxApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithSignupMaxMeta.signupMax,
      WithSignupMaxMeta,
      this.signupMax,
      this,
    );
  }
  signupMaxIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMaxIsSet && this.signupMaxApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.signupMaxIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
